<template>
  <div class="global-layout layout-default" :class="{ [`route-${$route.name}`]: $route.name }" data-test-layout-default>
    <MainHeader class="main-header" />
    <div
      ref="layoutContent"
      class="layout-content"
      :class="{
        padding: applyPadding,
      }"
      role="main"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import MainHeader from '@/components/navigation/MainHeader.vue';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      MainHeader,
    },
    computed: {
      applyPadding() {
        const noPaddingRoutes = ['shop'];

        return !noPaddingRoutes.includes(this.$route.name);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .layout-default {
    position: relative;
    width: 100%;
    min-height: 100svh;
    background-color: $color-gray-100;
  }

  .layout-content {
    width: 100;
    min-height: 100svh;
    max-width: $device-max-width;
    margin: 0 auto;
    padding: 2rem 2rem 6rem 2rem;

    @media (max-width: $tablet) {
      padding: 0;
    }
  }

  .padding {
    @media (max-width: $tablet) {
      max-width: unset;
      padding: 1rem 1rem;
    }
  }
</style>
